import React from 'react'
import Checkbox from '@cred/react-editors/checkbox'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'

const CheckboxDisclosure = ({name, id, validate, children, onChange}) =>
  <div className={styles.disclosureCheckbox}>
    <Checkbox {...{name, id, validate, onChange}}/>
    <label className={styles.disclosureLabel} htmlFor={id}>
      <div>{children}</div>
    </label>
  </div>

CheckboxDisclosure.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
  validate: PropTypes.func
}

CheckboxDisclosure.defaultProps = {validate: () => {}}

export default CheckboxDisclosure
